import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';
import LoadingAnimation from '../loading/components/LoadingAnimation';

export default createLoadableComponent(() => import('./containers/LoginContainer'), {
  FallbackComponent: LoadingAnimation,
});
